import React from 'react';

interface TimerProps {
  elapsed: string;
  className?: string;
  'aria-label'?: string;
}

export function Timer({ elapsed, className = '', 'aria-label': ariaLabel }: TimerProps) {
  return (
    <div className={`font-mono text-sm text-gray-600 ${className}`} aria-label={ariaLabel}>
      {elapsed}
    </div>
  );
}

